import { render, staticRenderFns } from "./TableComponentMundial.vue?vue&type=template&id=4dcf8972&scoped=true&"
import script from "./TableComponentMundial.vue?vue&type=script&lang=js&"
export * from "./TableComponentMundial.vue?vue&type=script&lang=js&"
import style0 from "./TableComponentMundial.vue?vue&type=style&index=0&id=4dcf8972&prod&lang=css&"
import style1 from "./TableComponentMundial.vue?vue&type=style&index=1&id=4dcf8972&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcf8972",
  null
  
)

export default component.exports